"use client";

import React, { createContext, useContext } from "react";
import type { ManageTripsRuntimeConfig } from "@jb-manage-trips/types/config";

const ManageTripsConfigContext = createContext<ManageTripsRuntimeConfig | null>(
  null,
);

export function ManageTripsConfigProvider({
  value,
  children,
}: {
  value: ManageTripsRuntimeConfig;
  children: React.ReactNode;
}) {
  return (
    <ManageTripsConfigContext.Provider value={value}>
      {children}
    </ManageTripsConfigContext.Provider>
  );
}

export function useManageTripsConfig(): ManageTripsRuntimeConfig {
  const ctx = useContext(ManageTripsConfigContext);
  if (!ctx) {
    throw new Error(
      "ManageTripsConfig is missing. Wrap your tree in <ManageTripsConfigProvider>.",
    );
  }
  return ctx;
}
